import React, { useContext } from "react";
import Link from "next/link";
import { SubscriptionContext } from "../../services/SubscriptionService";
import styles from "./styles.scss";
import { AffiliateLink, getOfferId, OfferItem, useOfferStates } from "src/services/OfferService";

export type OfferPreviewItem = {
  id: string;
  welcomeOffer: string;
  limitedOffer?: string;
  imageUrl: string;
  affiliateLinkWeb: string;
};

export function OffersPreviewStack() {
  const { userLocale } = useContext(SubscriptionContext);
  const { data: offerStates, loading } = useOfferStates();
  const stateIndex = Math.max(
    0,
    offerStates.findIndex((state) => state.abbreviation === userLocale)
  ); // eslint-disable-line
  const offerState = offerStates[stateIndex];
  const offers = (offerState?.sportsbook_offers ?? []).slice(0, 5);

  let offersAsUrl = "/sportsbook-offers";
  if (userLocale) {
    offersAsUrl += `/${userLocale.toLowerCase()}`;
  }

  let linkText = "See all offers";
  if (userLocale) {
    linkText = `See all ${offerStates[stateIndex]?.name ?? ""} offers`;
  }

  if (!offers.length && !loading) {
    return null;
  }

  return (
    <div className="offers-preview-stack">
      <div className="offers-preview-stack__heading">Offers From BetQL</div>
      <div className="offers-preview-stack__stack">
        {loading
          ? [1, 2, 3, 4, 5].map((index) => {
              return <OfferCardPlaceholder key={index} />;
            })
          : offers.map((offer: OfferItem) => {
              return <OfferCard key={offer._meta.id} offer={offer} />;
            })}
        <Link passHref href={offersAsUrl} legacyBehavior>
          <a className="offers-preview-stack__more">{linkText}</a>
        </Link>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}

const OfferCardPlaceholder = () => {
  return (
    <div className="offers-preview-stack__item" style={{ height: 64 }}>
      <div className="image placeholder" style={{ width: 90, height: "100%" }} />
      <div className="inner" style={{ flex: 1, height: "100%" }}>
        <div className="heading placeholder" style={{ width: 194, height: "100%" }} />
      </div>
    </div>
  );
};

const OfferCard = ({ offer }: { offer: OfferItem }) => {
  return (
    <div key={getOfferId(offer)} className="offers-preview-stack__item">
      <img data-src={offer.image.url} className="lazyload" />
      <div className="inner">
        <AffiliateLink className="heading" href={offer.web_link} target="_blank" rel="noopener">
          {offer.welcome_offer}
        </AffiliateLink>
      </div>
    </div>
  );
};
